import {
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Checkbox,
  DatePicker,
} from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  accounts: any[];
  currencies: any[];
  // sources: any[];
  sellers: any[];
  customerTypes: any[];
}

const CustomerFormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  accounts,
  currencies,
  sellers,
  customerTypes,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل عميل" : "إضافة عميل"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {isEditing && (
              <Form.Item name="CustomerID" label="كود العميل">
                <InputNumber
                  placeholder="كود العميل"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}
            <Form.Item
              name="CustomerName"
              label="اسم العميل"
              rules={[{ required: true, message: "الرجاء إدخال اسم العميل" }]}
            >
              <Input placeholder="اسم العميل" className="w-full" />
            </Form.Item>

            <Form.Item name="CustTypeID" label="نوع العميل ">
              <Select
                placeholder="نوع العميل "
                allowClear
                options={customerTypes.map((type: any) => ({
                  label: type.CustTypeName,
                  value: type.CustTypeID,
                }))}
              />
            </Form.Item>
            <Form.Item name="Address" label="العنوان">
              <Input placeholder="العنوان" className="w-full" />
            </Form.Item>
            <Form.Item name="Phone" label="الهاتف">
              <Input placeholder="الهاتف" className="w-full" />
            </Form.Item>
            <Form.Item name="Mobile" label="الموبايل">
              <Input placeholder="الموبايل" className="w-full" />
            </Form.Item>
            <Form.Item name="Fax" label="الفاكس">
              <Input placeholder="الفاكس" className="w-full" />
            </Form.Item>
            <Form.Item name="EMail" label="البريد الإلكتروني">
              <Input placeholder="البريد الإلكتروني" className="w-full" />
            </Form.Item>
            <Form.Item name="CreditLimit" label="حد الائتمان">
              <InputNumber className="w-full" />
            </Form.Item>
            <Form.Item name="CreditLimitPeriod" label="مدة الائتمان">
              <InputNumber className="w-full" />
            </Form.Item>
            <Form.Item name="SellerID" label="مندوب البيع">
              <Select placeholder="اختر المندوب" className="w-full">
                {sellers.map((seller) => (
                  <Select.Option key={seller.SellerID} value={seller.SellerID}>
                    {seller.SellerName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="CurrID" label="العملة">
              <Select placeholder="اختر العملة" className="w-full">
                {currencies.map((currency) => (
                  <Select.Option key={currency.CurrID} value={currency.CurrID}>
                    {currency.CurrName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="CurrRate" label="سعر العملة">
              <InputNumber className="w-full" />
            </Form.Item>
            <Form.Item name="FirstBalDate" label="تاريخ الرصيد الأولي">
              <DatePicker className="w-full" />
            </Form.Item>
            <Form.Item name="FirstBal" label="الرصيد الأولي">
              <InputNumber className="w-full" />
            </Form.Item>

            {/* <Form.Item name="CustPricing" label="نوع التسعير">
              <InputNumber className="w-full" />
            </Form.Item> */}
            <Form.Item name="PriceListNo" label="رقم قائمة الأسعار">
              <InputNumber className="w-full" />
            </Form.Item>
            <Form.Item name="AccId" label="معرف الحساب">
              <Select placeholder="اختر الحساب" className="w-full">
                {accounts.map((acc) => (
                  <Select.Option key={acc.AccID} value={acc.AccID}>
                    {acc.AccName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="CarType" label="نوع السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="CarModal" label="موديل السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="CarChasie" label="شاسيه السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="CarColor" label="لون السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="CarMotor" label="موتور السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="CarInjen" label="انجن السيارة">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="NationalId" label="الرقم القومي">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="TaxCrad" label="بطاقة ضريبية">
              <Input className="w-full" />
            </Form.Item>
            <Form.Item name="TaxNo" label="الرقم الضريبي">
              <Input className="w-full" />
            </Form.Item>
            <div className="col-span-1 md:col-span-2 lg:col-span-3 flex flex-wrap gap-4">
              <Form.Item name="IsDebit" valuePropName="checked">
                <Checkbox>مدين</Checkbox>
              </Form.Item>
              <Form.Item name="IsCredit" valuePropName="checked">
                <Checkbox>دائن</Checkbox>
              </Form.Item>
              <Form.Item name="IsStoped" valuePropName="checked">
                <Checkbox>متوقف</Checkbox>
              </Form.Item>
              <Form.Item name="IsVendorCustomer" valuePropName="checked">
                <Checkbox>مشترك مورد/عميل</Checkbox>
              </Form.Item>
            </div>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default CustomerFormModal;
